var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-info"},[(_vm.isTiktokEmpty)?_c('EmptyUser',{on:{"clickEmptyUser":_vm.clickEmptyUser}}):_c('UserBaseInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }